export default __webpack_public_path__ + "static/media/5.0a2ba59d.jpg";